import '../assets/css/navbar.css';
//import ATOLogo from '../assets/ato-logo.png';

//import { faBars } from '@fortawesome/free-solid-svg-icons';
import { faChevronCircleLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import React, { useContext } from 'react';
import React from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';

// import { NftContext } from '../providers/NftProvider';

let antixx = false;
if(window.location.hostname.match("ato-antixx")) {
  antixx = true;
}

const Navbar = () => {
  const goBackPath = ['/details/', '/seePdf', '/create'];
  const history = useHistory();
  // const nftInfos = useContext(NftContext);

  /**
   * Handle search bar input change
   * @param {string} search
   * faSearch -> fontawesome
   */
  // const handleSearch = (search) => {
  //   nftInfos.setResearch(search.toLowerCase());
  // };

  return (
    <Switch>
      <Route exact path="/">
        <div className="hide3"></div>
        <div className="container">
          <div className="row">
            <div className="col col-6 col-sm-3 back">
              <span className="logo">
                Āto
              </span>
            </div>
            
            {/* <div className="col col-xl-0 offset-xl-0 offset-lg-9 offset-md-8 offset-sm-8 col-6 offset-10 back2">
              <span className="menu-button">
                <FontAwesomeIcon icon={faBars} size="2x" data-bs-toggle="offcanvas" data-bs-target="#offcanvas1" />
              </span>
            </div> */}
            {/*<div className="col offset-lg-9 offset-xl-6 offset-md-8 offset-sm-7 col-3 offset-10 back2">*/}
            {/*<div className="col-6 offset-3 col-sm-3 back2">
              <span className="menu-button">
                <img src={ATOLogo} alt="ato-logo.png" className="transparent" style={{width: "45px", height: "auto"}}></img>
              </span>
          </div>*/}
          </div>
        </div>
      </Route>

      <Route path="/create">
        {/*<div className="hide2"></div>*/}
        <div className="wrapper">
        <div className="container">
          <div className="row">
            {/* <div className="col col-4 col-sm-3 col-2 back">
              <span className="logo" onClick={() => history.push('/')}>
                Āto
              </span>
            </div> */}
            {/* col-xl-2 className="col col-12 col-sm-5 offset-sm-0 offset-xl-0 offset-lg-0 col-md-5 offset-md-0 text-center back3" */}
            <div className="col-12 col-md-5">
              <button className="btn btn-pill mr-3 mt-3 backbutton" onClick={history.goBack}>
                <span aria-hidden="true">
                  <FontAwesomeIcon icon={faChevronCircleLeft} size="2x" />{' '}
                </span>
              </button>
            </div>
            {/* offset-xl-3  className="offset-3 col-sm-6 offset-sm-0 col-xl-5 col-lg-6 offset-lg-4 col-md-7 offset-md-4 back4"*/}
            <div className="col-sm-12 col-md-7">
              <h4 className="upload">{antixx ? "Antixx Minter":"Create your NFT"}</h4>
            </div>

            {/* <div className="offset-lg-9 offset-xl-6 offset-md-8 offset-sm-8 col-3 offset-10 back2">
              <span className="menu-button">
                <FontAwesomeIcon icon={faBars} size="2x" data-bs-toggle="offcanvas" data-bs-target="#offcanvas1" />
              </span>
            </div> */}
          </div>
        </div>
        </div>
      </Route>

      <Route path="/login">
        <div className="container">
          <div className="row">
            <div className="col col-4 col-sm-3 col-2 back">
              <span className="logo">Āto</span>
            </div>
            <div className="col col-sm-6 col-xl-5 offset-xl-1 col-lg-5 offset-lg-2 col-md-5 offset-md-2 offset-sm-2 col-6 offset-2 input"></div>
            {/* <div className="col offset-lg-9 offset-xl-6 offset-md-8 offset-sm-7 col-3 offset-10 back2">
              <span className="menu-button">
                <FontAwesomeIcon icon={faBars} size="2x" data-bs-toggle="offcanvas" data-bs-target="#offcanvas1" />
              </span>
            </div> */}
          </div>
        </div>
      </Route>

      <Route path="/profile">
        <div className="container">
          <div className="row">
            <div className="col col-4 col-sm-3 col-2 back">
            <span className="logo">
            Āto
              </span>
            </div>
            <div className="col col-sm-6 col-xl-5 offset-xl-1 col-lg-5 offset-lg-2 col-md-5 offset-md-2 offset-sm-2 col-6 offset-2 input"></div>
            {/* <div className="col offset-lg-9 offset-xl-6 offset-md-8 offset-sm-7 col-3 offset-10 back2">
              <span className="menu-button">
                <FontAwesomeIcon icon={faBars} size="2x" data-bs-toggle="offcanvas" data-bs-target="#offcanvas1" />
              </span>
            </div> */}
          </div>
        </div>
      </Route>

      <Route path={goBackPath.map((path) => path)}>
        <div className="hide"></div>
        <div className="container">
          <div className="row">
            <div className="col-8 offset-0 col-sm-5 offset-sm-0 col-xl-2 offset-xl-0 offset-lg-0 col-md-4 offset-md-0 text-center back3">
              <button className="btn  btn-pill mr-3 backbutton" onClick={history.goBack}>
                <span aria-hidden="true">
                  <FontAwesomeIcon icon={faChevronCircleLeft} size="2x" />{' '}
                </span>
              </button>
            </div>
          </div>
        </div>
      </Route>
    </Switch>
  );
};

export default Navbar;
